var _style, _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMommiesFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgQrWrapper",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 300,
    style: {
      width: "100%",
      height: "100%",
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9, 9)scale(0.95)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".background-color{ fill: #fff; }.dot-color{ fill: #000000; }.corners-square-color-0-0{ fill: #000000; }.corners-dot-color-0-0{ fill: #000000; }.corners-square-color-1-0{ fill: #000000; }.corners-dot-color-1-0{ fill: #000000; }.corners-square-color-0-1{ fill: #000000; }.corners-dot-color-0-1{ fill: #000000; }")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dot-color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,10,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,10,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,10,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,10,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,10,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,20,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,20,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,20,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,20,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,30,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,30,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,30,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,30,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,30,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,40,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,40,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,40,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,40,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,40,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,40,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,40,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,50,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,50,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,50,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,50,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,50,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,50,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,60,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,60,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,60,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,60,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,60,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,60,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,70,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,70,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,70,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,70,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,70,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,70,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,70,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,80,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,80,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,80,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,80,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,80,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,80,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,80,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,80,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,80,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,80,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,90,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,90,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,90,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,90,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,90,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,90,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,90,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,90,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,90,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,90,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,90,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,90,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,90,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,90,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,100,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,100,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,100,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,100,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,100,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,100,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,100,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,100,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,100,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,100,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,100,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,100,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,110,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,110,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,110,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,110,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,110,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,110,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,110,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,110,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,110,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,110,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,110,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,110,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,110,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,110,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,110,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,110,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,120,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,120,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,120,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,120,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,120,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,120,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,120,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,120,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,120,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,120,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,120,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,120,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,120,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,120,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,130,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,130,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,130,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,130,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,130,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,130,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,130,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,130,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,130,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,130,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,130,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,130,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,130,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,130,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,130,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,130,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,140,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,140,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,140,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,140,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,140,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,140,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,140,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,140,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,140,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,140,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,140,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,140,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,140,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,140,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,140,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,150,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,150,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,150,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,150,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,150,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,150,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,150,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,150,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,150,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,150,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,150,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,150,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,150,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,160,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,160,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,160,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,160,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,160,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,160,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,160,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,160,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,160,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,160,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,160,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,160,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,160,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,160,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,160,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,160,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,170,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,170,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,170,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,170,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,170,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,170,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,170,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,170,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,170,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,180,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,180,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,180,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,180,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,180,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,180,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,180,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,180,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,180,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,190,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,190,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,190,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,190,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,190,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,190,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,190,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,190,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,190,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,190,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,190,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,190,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,190,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,190,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,190,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,190,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,200,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,200,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,200,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,200,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,200,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,200,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,200,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,200,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,200,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,200,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,200,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,200,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,210,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,210,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,210,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,210,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,210,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,210,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,210,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,210,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,210,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,210,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,210,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,210,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,210,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,210,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,210,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,210,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,210,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,210,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,220,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,220,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,220,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,220,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,220,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,220,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,220,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,220,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,220,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,230,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,230,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,230,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,230,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,230,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,230,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,230,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,230,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,230,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,230,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,230,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,230,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,240,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,240,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,240,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,240,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,240,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,240,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,240,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,240,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,240,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,240,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,240,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,250,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,250,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,250,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,250,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,250,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,250,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,250,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,250,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,250,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,250,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,250,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,260,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,260,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,260,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,260,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,260,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,260,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,260,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,260,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,260,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,260,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,270,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,270,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,270,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,270,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,270,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,270,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,270,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,270,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,270,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,280,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,280,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,280,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,280,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,280,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,280,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,280,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,280,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,290,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,290,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,290,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,290,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,290,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,290,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,290,290)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "corners-square-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 5 30v 20a 25 25, 0, 0, 0, 25 25h 45v -45a 25 25, 0, 0, 0, -25 -25h -20a 25 25, 0, 0, 0, -25 25M 30 15h 20a 15 15, 0, 0, 1, 15 15v 35h -35a 15 15, 0, 0, 1, -15 -15v -20a 15 15, 0, 0, 1, 15 -15",
    transform: "rotate(0,40,40)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "corners-dot-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 25 35.714285714285715v 8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, 10.714285714285714 10.714285714285714h 19.285714285714285v -19.285714285714285a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 -10.714285714285714h -8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 10.714285714285714",
    transform: "rotate(0,40,40)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "corners-square-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 225 30v 20a 25 25, 0, 0, 0, 25 25h 45v -45a 25 25, 0, 0, 0, -25 -25h -20a 25 25, 0, 0, 0, -25 25M 250 15h 20a 15 15, 0, 0, 1, 15 15v 35h -35a 15 15, 0, 0, 1, -15 -15v -20a 15 15, 0, 0, 1, 15 -15",
    transform: "rotate(90,260,40)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "corners-dot-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 245 35.714285714285715v 8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, 10.714285714285714 10.714285714285714h 19.285714285714285v -19.285714285714285a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 -10.714285714285714h -8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 10.714285714285714",
    transform: "rotate(90,260,40)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "corners-square-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 5 250v 20a 25 25, 0, 0, 0, 25 25h 45v -45a 25 25, 0, 0, 0, -25 -25h -20a 25 25, 0, 0, 0, -25 25M 30 235h 20a 15 15, 0, 0, 1, 15 15v 35h -35a 15 15, 0, 0, 1, -15 -15v -20a 15 15, 0, 0, 1, 15 -15",
    transform: "rotate(-90,40,260)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "corners-dot-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 25 255.71428571428572v 8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, 10.714285714285714 10.714285714285714h 19.285714285714285v -19.285714285714285a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 -10.714285714285714h -8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 10.714285714285714",
    transform: "rotate(-90,40,260)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMommiesFb);
export default __webpack_public_path__ + "static/media/mommiesFB.743e6a78e2f58483786563bae67ba773.svg";
export { ForwardRef as ReactComponent };